import React from "react";
import {toast, Toaster} from 'react-hot-toast';
import BrazilMap from "./BrazilMap";
import { useAuth } from '../AuthContext';
import { useEffect,useState } from "react";
import ApiData from "../ApiData";
import logoImg from '../assets/Union.png'
import {Button} from 'ui-kit-takeat';
import { useAsyncError, useNavigate } from 'react-router-dom';
import { Select } from 'takeat-design-system-ui-kit';
import DataCard from "./DataCard";
import Loading from "./Loading";
import { SimpleTable } from "ui-kit-takeat";
import { Link } from 'react-router-dom';
import { Dropdown } from "takeat-design-system-ui-kit";
import DonutGraph from "./PieGraph";
import HeatMapBrazil from "./HeatMapBrazil";
import cityData from "../BrazilianCitiesMap/municipios.json"
import { Switch } from "takeat-design-system-ui-kit";
import { FaInfoCircle } from "react-icons/fa"; // Ícone de informação
const getCityCoordinates = (cityName) => {
  const city = cityData.find(c => c.nome.toLowerCase() === cityName.toLowerCase());
  return city ? { lat: city.latitude, lon: city.longitude } : null;
};
const GeneralData = () => {
  const pieColors = ["#FFE4E1", "#FFA07A", "#FA8072","#FF6347","#B22222","#800000"]
  const [rest25K,setRest25K] = useState();
  const [rest50K,setRest50K] = useState();
  const [rest100K,setRest100K] = useState();
  const [rest150K,setRest150K] = useState();
  const [rest200K,setRest200K] = useState();
  const [heatMap,setHeatMap] = useState(false);
  const [rest200KMais,setRest200KMais] = useState();
  const [butao, setButao] = useState(false);
  const [restaurants,setRestaurants] = useState([]); 
  const [meanTotalMRR, setMeanTotalMRR] = useState();
  const [meanTotalSurvivalDays,setMeanTotalSurvivalDays] = useState();
  const [meanMRR,setMeanMRR] = useState();
  const [meanTempoDeUso,setMeanTempoDeUso] = useState();
  const [cityMarkers,setCityMarkers] = useState();
  const [filters, setFilters] = useState({
    has_clube: false,
    has_pos: false,
    has_totem: false,
    is_deleted: false,
    is_not_deleted: true,
    inativo: false,
    faturamento: false, 
    faturamento_25K: false ,
    faturamento_50K: false,
    faturamento_100K: false,
    faturamento_150K: false,
    faturamento_200K: false,
    has_address: false
  });
  

const [citiesData,setCitiesData] = useState([]);

const [selectedCitiesData,setSelectedCitiesData] = useState([]);

const [mapData,setMapData] = useState([]);


const navigate = useNavigate();
const{logout} = useAuth();
const handleLogout= () =>{
    logout();
    navigate('/login');

  };

const fetchMapData = async () => {
  try {
    const response_restaurants = await ApiData.post({}, "general/restaurants");
    const response_faturamento = await ApiData.post({}, "general/comandas");

    const restaurantsWithFaturamento = response_restaurants.data.restaurants.map((restaurant) => {


      const faturamento = response_faturamento.data.restaurants.find(
        (f) => f.restaurant_id === restaurant.id
      );
      

      return {
        ...restaurant,
        faturamento: faturamento ? faturamento.faturamento : 0,
        last_session_date: faturamento? faturamento.last_session_date : 0
      };
    });
    let rest25K = 0;
    let rest50K = 0;
    let rest100K = 0;
    let rest150K = 0;
    let rest200K = 0;
    let rest200KMais = 0;
    
    const internalCitiesData = []

    for (const restaurant of restaurantsWithFaturamento) {
      if (restaurant.faturamento >= 0 && restaurant.faturamento <= 25000 && restaurant.is_deleted === 0) {
        rest25K++;
      } else if (restaurant.faturamento > 25000 && restaurant.faturamento <= 50000) {
        rest50K++;
      } else if (restaurant.faturamento > 50000 && restaurant.faturamento <= 100000) {
        rest100K++;
      } else if (restaurant.faturamento > 100000 && restaurant.faturamento <= 150000) {
        rest150K++;
      } else if (restaurant.faturamento > 150000 && restaurant.faturamento <= 200000) {
        rest200K++;
      } else if (restaurant.faturamento > 200000) {
        rest200KMais++;
      }

  // Obtém as coordenadas da cidade
  const cord = restaurant.city?getCityCoordinates(restaurant.city):console.log('Nulo');

  // Se as coordenadas forem encontradas e ainda não estiverem no array, adiciona
  if (cord) {
    const alreadyExists = internalCitiesData.some(
      ([lat, lon]) => lat === parseFloat(cord.lat) && lon === parseFloat(cord.lon)
    );

    if (!alreadyExists) {
      internalCitiesData.push([restaurant.city,parseFloat(cord.lat), parseFloat(cord.lon)]);
    }
  }

    }
    setCitiesData(internalCitiesData);
    setRest25K(rest25K);
    setRest50K(rest50K);
    setRest100K(rest100K);
    setRest150K(rest150K);
    setRest200K(rest200K);
    setRest200KMais(rest200KMais);
    console.log(internalCitiesData);
    setMeanTotalMRR(response_restaurants.data.mean_mrr);
    setMeanTotalSurvivalDays(response_restaurants.data.mean_survival_days);
    setRestaurants(restaurantsWithFaturamento);

    

  } catch (error) {
    console.error('Erro ao buscar dados:', error);
  }
}

const handleFilterChange = (e) => {
  const { name, checked } = e.target;

  // Atualiza o filtro selecionado
  setFilters((prevFilters) => ({
    ...prevFilters,
    [name]: checked,
    ...(name.startsWith("faturamento") && { // Se for filtro de faturamento
      faturamento: name === "faturamento" ? checked : false,
      faturamento_25K: name === "faturamento_25K" ? checked : false,
      faturamento_50K: name === "faturamento_50K" ? checked : false,
      faturamento_100K: name === "faturamento_100K" ? checked : false,
      faturamento_150K: name === "faturamento_150K" ? checked : false,
      faturamento_200K: name === "faturamento_200K" ? checked : false,
    }),
  }));
};

const isAnySelected = Object.entries(filters)
.filter(([key]) => key.startsWith("faturamento")) // Considera apenas os filtros de faturamento
.some(([, value]) => value);
  useEffect(() => {
    fetchMapData();
  }, []);

const filteredRestaurants = restaurants.filter((restaurant) => {
  const { has_clube, has_pos, has_totem, is_deleted,is_not_deleted, 
    inativo, 
    faturamento,  
    faturamento_25K,
    faturamento_50K,
    faturamento_100K,
    faturamento_150K,
    faturamento_200K,
    has_address } = filters;

    const currentDate = new Date();
  return (
    (!has_clube || restaurant.has_clube === 1) &&
    (!has_pos || restaurant.has_pos === 1) &&
    (!has_totem || restaurant.has_totem === 1)&&
    (!is_deleted || restaurant.is_deleted === 1)&&
    (!is_not_deleted || restaurant.is_deleted === 0) &&
    (!faturamento || restaurant.faturamento<=25000) &&
    (!has_address || !restaurant.state && !restaurant.city ) &&
    (!inativo || (restaurant.last_session_date && (() => {

      const adjustedDate = new Date(restaurant.last_session_date);
      adjustedDate.setHours(adjustedDate.getHours() - 3);

      return (currentDate - adjustedDate) > 3 * 86400000;
    })())) &&
    (!faturamento_25K || (restaurant.faturamento>25000 && restaurant.faturamento<=50000 ) )&&
    (!faturamento_50K || (restaurant.faturamento>50000 && restaurant.faturamento<=100000) ) &&
    (!faturamento_100K || (restaurant.faturamento>100000 && restaurant.faturamento <=150000)) &&
    (!faturamento_150K || (restaurant.faturamento>150000 && restaurant.faturamento <= 200000)) &&
    (!faturamento_200K || restaurant.faturamento>200000)
  );
}); 

//console.log(filteredRestaurants);

useEffect(() =>{
  const stateCount = filteredRestaurants.reduce((acc, restaurant) => {
    const state = restaurant.state;
    if(state){
    const stateCode = `br-${restaurant.state.toLowerCase()}`;
    acc[stateCode] = (acc[stateCode] || 0) + 1;
    }
    
    
    return acc;
  }, {});

  const totalsAndAverages = filteredRestaurants.reduce(
    (totals, restaurant) => {
      if (restaurant.mrr) {
        totals.totalMrr += restaurant.mrr;
        totals.countMrr++;
      }
      if(restaurant.survival_days){
        totals.totalSurvivalDays += restaurant.survival_days;
        totals.countSurvivalDays++;
      }
      return totals;
    },
    { totalMrr: 0, countMrr: 0, totalSurvivalDays: 0, countSurvivalDays: 0 }
  );

  // Calcula as médias
  const imeanMrr = totalsAndAverages.countMrr > 0 
    ? totalsAndAverages.totalMrr / totalsAndAverages.countMrr 
    : meanTotalMRR;

  const imeanSurvivalDays = totalsAndAverages.countSurvivalDays > 0 
    ? totalsAndAverages.totalSurvivalDays / totalsAndAverages.countSurvivalDays 
    : meanTotalSurvivalDays;

  console.log("Média MRR:", imeanMrr);citiesData
  console.log("Média Survival Days:", imeanSurvivalDays);
  setMeanMRR(imeanMrr);
  setMeanTempoDeUso(imeanSurvivalDays);
  const mapDataArray = Object.entries(stateCount);
  setMapData(mapDataArray);

  const cityCount = filteredRestaurants.reduce((acc, restaurant) => {
    if (restaurant.city) {
      acc[restaurant.city] = (acc[restaurant.city] || 0) + 1;
    }
    return acc;
  }, {});

  const maxRestaurants = Math.max(...Object.values(cityCount), 1);


  const filteredCities = citiesData.filter(([cityName]) => cityCount[cityName]);

  
  const formattedCities = filteredCities.map(([cityName, lat, lon]) => [
    lat,
    lon,
    cityCount[cityName] / maxRestaurants, 
  ]);

  
  const cityMarkers = filteredCities.map(([cityName, lat, lon]) => ({
    city: cityName.toUpperCase(),
    lat,
    lon,
    restaurants: filteredRestaurants.filter((r) => r.city === cityName),
  }));

  setSelectedCitiesData(formattedCities); // Atualiza o heatmap
  setCityMarkers(cityMarkers); // Atualiza os marcadores
}, [filters, restaurants, citiesData]);





return(
  <div className="background_general_data">
        {Object.keys(restaurants).length === 0 &&<Loading/> }  

  <div className="dashboard_general">  

  {Object.keys(restaurants).length> 0 &&(
    <div className="background_general">
    
        
      
    <h1 className="sucesso-title">Parceiros</h1>

      <div className="general_selects" >

        <label>
        
          <input
            type="checkbox"
            name="has_clube"
            checked={filters.has_clube}
            onChange={handleFilterChange}
          />
          Tem Clube
        </label>

        <label>
        
          <input
            type="checkbox"
            name="has_pos"
            checked={filters.has_pos}
            onChange={handleFilterChange}
  />
          Tem POS
        </label>

        <label>
       
          <input
            type="checkbox"
            name="has_totem"
            checked={filters.has_totem}
            onChange={handleFilterChange}
          />
          Tem Totem
        </label>
        <label>
       
          <input
            type="checkbox"
            name="is_deleted"
            checked={filters.is_deleted}
            onChange={handleFilterChange}
          />
           Deletado
        </label>
        <label>
       
          <input
          type="checkbox"
          name="is_not_deleted"
          checked ={filters.is_not_deleted}
          onChange={handleFilterChange}
          />
          Não Deletado
        </label>
    <label>
       
       <input
       type="checkbox"
       name="has_address"
       checked ={filters.has_address}
       onChange={handleFilterChange}
       />
       Restaurantes sem Endereço
     </label>
        <label>
        
          <input
          type="checkbox"
          name="inativo"
          checked ={filters.inativo}
          onChange={handleFilterChange}
          
          />
          INATIVOS
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento"
          checked ={filters.faturamento}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento}
          />
          VENDAS 0k - 25k
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento_25K"
          checked ={filters.faturamento_25K}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento_25K}
          />
        VENDAS 25K - 50k
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento_50K"
          checked ={filters.faturamento_50K}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento_50K}
          />
        VENDAS 50K - 100K 
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento_100K"
          checked ={filters.faturamento_100K}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento_100K}
          />
        VENDAS 100K-150k 
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento_150K"
          checked ={filters.faturamento_150K}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento_150K}
          />
          VENDAS 150K - 200K
        </label>
        <label>
        
          <input
          type="checkbox"
          name="faturamento_200K"
          checked ={filters.faturamento_200K}
          onChange={handleFilterChange}
          disabled={isAnySelected && !filters.faturamento_200K}
          />
        VENDAS 200K +
        </label>

      </div>
      <Switch 
  label="Trocar para mapa de calor" 
  labelPosition="top"
  onChange={() => setHeatMap((prev) => !prev)} 
/>

{heatMap ? ( 
  <HeatMapBrazil data={selectedCitiesData} markers={cityMarkers} />
) : (
  <div style={{ width: "100vw" }}>
    <BrazilMap 
      title="" 
      data={mapData} 
      dataLabel="Restaurantes" 
      minColor="#FFEFD5" 
      maxColor="#800000" 
      style={{ height: "90vh", width: "70vw" }} 
    />
  </div>
)}

    </div>
    )}
   
    <div className="general_information">
   
    {(Object.keys(restaurants).length> 0 &&( <div style={{width: '50vw'}}>
 
 <div className="filtered-restaurants-container" >
  <div style={{flexDirection: 'column'}} >
  {<h1 className="sucesso-title" >Restaurantes Filtrados: {Object.keys(filteredRestaurants).length}</h1>}

 </div>
 <div>

 </div>
 <div className="filtered-restaurants-container-data">
 <SimpleTable header={['Nome', 'Cidade','Estado', 'Faturamento(30d)']} >
  
  <tbody>
    {filteredRestaurants
      .slice()
      .sort((a, b) => b.faturamento - a.faturamento) // Ordena do maior para o menor faturamento
      .map((restaurant) => (
        <tr key={restaurant.id}>
          <td>{restaurant.fantasy_name}</td>
          <td>{restaurant.city}</td>
          <td>{restaurant.state}</td>
          <td>R$ {restaurant.faturamento.toLocaleString("pt-BR", { minimumFractionDigits: 2 })} </td>
        </tr>
      ))}
  </tbody>
</SimpleTable>

  </div>
  </div>
</div>) )}

{(Object.keys(restaurants).length> 0 &&(

<div className="general_data_cards">
  <div className="general_data_card">
    <DataCard
      title={'$MRR médio'}
      value={meanMRR ? meanMRR : 0.00}
      tooltipText={"Receita recorrente mensal média dos restaurantes."} // Tooltip
    />
  </div>

  <div className="general_data_card">
    <DataCard
      title={'Tempo médio de uso'}
      value={meanTempoDeUso ? `${meanTempoDeUso.toPrecision(4)} dias` : 0.00}
      tooltipText={"Média de permanencia dos restaurantes filtrados."} // Tooltip
    />
  </div>
</div>

      
))}
{(Object.keys(restaurants).length> 0 &&(
<div className="general_pie_graph" >
  <h4 className="sucesso-title">Restaurantes por Faturamento</h4>
      <DonutGraph data={
        [{label: '0 a 25K' , value: rest25K},
          {label: '25K a 50K', value: rest50K},
          {label: '50K a 100K', value: rest100K},
          {label: '100K a 150K', value: rest150K},
          {label: '150K a 200K', value: rest200K},
          {label: '200K+',value: rest200KMais}

        ]
      } colors={pieColors}/>
    </div>))}

</div>

    </div>


    </div>
);
};
export default GeneralData;